// extracted by mini-css-extract-plugin
module.exports = {"container":"Skill_container__1S02g","skills":"Skill_skills__j_s4I","skill":"Skill_skill__3MM68"};